import Gifs from "../../components/Gifs/Gifs";
import GifsModule from "../../components/Gifs/GifsModule";
import TrendingComponent from "../../components/Trendings/TrendingComponent";

function Today() {
  return <GifsModule value="today" />;
}

export default Today;
